var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import PersistentCollection from '../PersistentCollection';
import ArchivedAssetModel from '../../models/ArchivedAssetModel';
import FilterRuleContainsString from '../filters/FilterRuleContainsString';
import SortModel from '../../models/SortModel';
import { compareDates, compareStrings } from '../../utils/compareUtils';
/**
 *
 */
var ArchivedAssetCollection = /** @class */ (function (_super) {
    __extends(ArchivedAssetCollection, _super);
    /**
     *
     */
    function ArchivedAssetCollection() {
        var _this = _super.call(this, ArchivedAssetModel, true, 'ArchivedAssetCollection-v2') || this;
        // Entries cached by earlier builds have no id and cannot be restored.
        ['ArchivedAssetCollection', 'ArchivedAssetCollection-filters', 'ArchivedAssetCollection-sort'].forEach(function (key) {
            try {
                localStorage.removeItem(key);
            }
            catch (e) {
                console.log(e);
            }
        });
        _this.sort = new SortModel();
        _this.searchStringFilter = new FilterRuleContainsString('filterString');
        _this.filter.addRule(_this.searchStringFilter);
        return _this;
    }
    /**
     *
     * @param items
     * @return {*}
     * @private
     */
    ArchivedAssetCollection.prototype.applySort = function (items) {
        var sort = this.sort;
        if (!sort)
            return items;
        var result = items.concat([]);
        result.sort(function (a, b) {
            switch (sort.fieldName) {
                case 'id':
                    return compareStrings(a.displayedId, b.displayedId);
                case 'make':
                    return compareStrings(a.make, b.make);
                case 'model':
                    return compareStrings(a.model, b.model);
                case 'reason':
                    return compareStrings(a.reason, b.reason);
                case 'serialNumber':
                    return compareStrings(a.serialNumber, b.serialNumber);
                case 'lastModifiedTimestamp':
                    return compareDates(a.lastModifiedTimestamp, b.lastModifiedTimestamp);
            }
        });
        if (sort.direction < 0) {
            result.reverse();
        }
        return result;
    };
    return ArchivedAssetCollection;
}(PersistentCollection));
export default ArchivedAssetCollection;
